module.exports = {
    MODE: 'test',
    LOCAL_HOST: 'https://test3.blotclub.am',
    API_HOST: 'https://test3.blotclub.am/api',
    API_PORT: '3300',
    SOCKET_HOST: 'test3.blotclub.am/socket',
    SOCKET_PORT: '',
};
